module.exports = __webpack_public_path__ + "img/jycx.b5f49580.svg";